import { Box, Typography } from '@mui/material'
import colors from '../../constants/colors'
import Navbar from '../Navbar'

const MobileViewPage: React.FC = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        flexGrow: 1,
        minHeight: '100vh',
        minWidth: '100vw',
        backgroundColor: colors.TAG_MAIN_BACKGROUND,
      }}
    >
      <Navbar />
      <Box
        sx={{
          marginTop: '12rem',
          display: 'flex',
          flexDirection: 'column',
          gap: '4rem',
          padding: '1.8rem',
        }}
      >
        <Typography color={colors.TAG_BLUE} variant='boldText45' sx={{ whiteSpace: 'pre-line' }}>
          {'Please log on \n with a desktop computer'}{' '}
        </Typography>
        <Typography
          color={colors.TAG_BLUE}
          variant='boldTextXlarge'
          sx={{ whiteSpace: 'pre-line' }}
        >
          {
            ' We’re sorry, our system isn’t optimized for smaller screens.\nTo continue completing your investigation, please log on \n with a desktop computer.'
          }
        </Typography>
      </Box>
    </Box>
  )
}

export default MobileViewPage
